export default "__VITE_ASSET__ce8a0b13__"